import { /* Circle, */ LayersControl, MapContainer, TileLayer } from 'react-leaflet'
import AddLocationModal from 'components/Modal/AddLocationModal'
// import DeleteLocationModal from './DeleteLocationModal'
import useFetchedData from 'hooks/useFetchedData'
import BottomBar from 'components/BottomBar'
import React, { useEffect, useState } from 'react'
import TopBar from 'components/Topbar'
import * as urls from 'api/urls'
import Markers from './Markers'
import './index.scss'

import 'leaflet/dist/leaflet.css'

const Map: React.FC = () => {
  const { data, reload, isLoading } = useFetchedData<places.PlacesResponse>(urls.places)

  const [isModal, setModal] = useState<string>('')
  const [infoVisible, setInfoVisible] = useState<boolean>(false)
  // const [pinID, setPinID] = useState<string>('')

  useEffect(() => {
    if (!isLoading && data) {
      setInfoVisible(data.myBoards?.length === 0 && data.savedBoards?.length === 0)
    }
  }, [isLoading, data])

  return (
    <>
      {isModal === 'addLocation' && <AddLocationModal onClose={() => setModal('')} onReload={reload} />}
      {/* {isModal === 'delete' && <DeleteLocationModal onClose={() => setModal('')} locationId={pinID} onReload={reload}/>} */}
      <div className="map">
        <TopBar isSticky={true} theme='dark' />
        <MapContainer
          zoom={window.innerWidth > 800 ? 7 : 6}
          minZoom={0}
          maxZoom={20}
          center={[52, 19]}
          className='map__leaflet'
          scrollWheelZoom={true}>

          <LayersControl>
            <LayersControl.BaseLayer checked name="Ulice">
              <TileLayer
                maxZoom={20}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
                url={`https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png`}
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Satelita">
              <TileLayer
                maxZoom={20}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
                url={`https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`}
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
              />
            </LayersControl.BaseLayer>
          </LayersControl>

          {/* User position */}
          {/* {markerPosition && distance && <Circle
            center={markerPosition}
            radius={distance * 1000}
            pathOptions={{ fillColor: 'none', color: '#f1416c' }}
          />} */}

          <Markers data={data} />
        </MapContainer>
        {/* <div className='btn--action' onClick={() => setModal('addLocation')}><i className="icon icon--add s32"></i></div> */}

        {infoVisible && <div className="mapInfo">
          <div>
            <div className="iconWrap" onClick={() => setInfoVisible(false)}>
              <i className="icon icon--close" ></i>
            </div>
            <p>   Dodaj osobę wraz z lokalizacją
              lub uzupełnij lokalizację istniejących
              profili, aby wyświetlić osoby na mapie.
            </p>
          </div>
        </div>}
        <BottomBar />
      </div>
    </>)
}

export default Map